import { http } from './http';

export async function readDataHealth() {
  const { data } = await http.get('/indicator-data/data-health');
  return Array.isArray(data) ? data : [];
}
